import { atom } from "recoil";
export const chatDataAtom = atom({
  key: "online-chat-data",
  default: [],
});

export const newMessage = atom({
  key: "new-message-chat-data",
  default: "",
});
